export enum EnumSubtipoSujeto {
  Domestico = 1,
  ComunidadPropietarios,
  Pyme,
  Administracion,
  Industrial,
  Broker,
  Mercado,
  Gasinera,
  Mayorista,
  DomesticoGrupo = 20,
  HotelResort,
  HotelResortGrupo,
  PymeGrupo,
  IndustrialGrupo,
  GNV_GNL,
  GNV_GNC,
  GNV_GNLC,
  Camionero = 29,
  Licitacion,
  Residencial_Comunidades,
  Vehicular,
  LicitacionSinCuota,
  AdministracionSinCuota,
  IG_Intra_Group = 100,
  NG_Non_Group,
  FN_Foreign_Non_Group,
  NG_Mayorista,
  NG_Transportista,
  IG_Mayorista,
  NG_Comercial,
  NG_Non_Group_Dist,
  NG_Licitacion,
  Socio,
  ConsumidorDirecto
}
